import { atom } from 'jotai';

import { executionRunsListQueryAtom } from '../_graphql/queryExecutionRuns';
import { automationsRoutes } from '../routes';
import { ExecutionStatus, ExecutionRunSortOption } from '../types';

import {
  atomFromRoutePath,
  atomFromQueryString,
} from '~/shared/state/location.state';

// Route Parameters - Use detail route since executions are a tab within detail view
const $executionsIdFromRoute = atomFromRoutePath(automationsRoutes.detail);

export const $executionsAutomationId = atom((get) => {
  const params = get($executionsIdFromRoute) as { id?: string } | null;
  const id = params?.id;
  return id && id !== 'new' ? String(id) : undefined;
});

// Query String Parameters
export const $executionsStatus =
  atomFromQueryString.string<ExecutionStatus>('execStatus');
export const $executionsFromDate = atomFromQueryString.string('execFromDate');
export const $executionsToDate = atomFromQueryString.string('execToDate');
export const $executionsIsTest = atomFromQueryString.boolean('isTest');
export const $executionsSortOption =
  atomFromQueryString.string<ExecutionRunSortOption>(
    'execSort',
    'TriggeredAtDesc',
  );
export const $executionsLimit = atomFromQueryString.number('execLimit', 25);
export const $executionsOffset = atomFromQueryString.number('execOffset', 0);

// Computed Data - Query Params
export const $executionRunsParams = atom((get) => {
  const automationId = get($executionsAutomationId);
  const status = get($executionsStatus);
  const fromDate = get($executionsFromDate);
  const toDate = get($executionsToDate);
  const isTest = get($executionsIsTest);
  const sortOption = get($executionsSortOption);
  const limit = get($executionsLimit);
  const offset = get($executionsOffset);

  const params: {
    automationId?: string;
    status?: ExecutionStatus[];
    fromDate?: string;
    toDate?: string;
    isTest?: boolean;
    sorting?: ExecutionRunSortOption[];
    limit: number;
    offset: number;
  } = {
    limit,
    offset,
  };

  if (automationId) params.automationId = automationId;
  if (status) params.status = [status];
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  if (isTest !== null && isTest !== undefined) params.isTest = isTest;
  if (sortOption) params.sorting = [sortOption];

  return params;
});

// Remote Data
export const $remoteExecutionRuns = executionRunsListQueryAtom((get) => {
  const params = get($executionRunsParams);
  return {
    variables: params,
    skip: !params.automationId,
  };
});
